import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

export const fetchChecklists = async () => {
    const response = await fetch(`/api/operational/checklist-instances`);
    if (!response.ok) {
        throw new Error('Failed to fetch checklists');
    }
    return response.json();
};

export const useChecklists = () => {
    return useQuery({
        queryKey: ['checklists'],
        queryFn: fetchChecklists
    });
};

export const createChecklist = async (data) => {
    const response = await fetch(`/api/operational/checklist-instances`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) {
        throw new Error('Failed to create checklist');
    }
    return response.json();
};

export const getChecklist = async (id) => {
    const response = await fetch(`/api/operational/checklist-instances/${id}`);
    if (!response.ok) {
        throw new Error(`Failed to fetch checklist ${id}`);
    }
    return response.json();
}

export const useChecklistDetails = (id) => {
    return useQuery({
      queryKey: ['checklist', id],
      queryFn: () => getChecklist(id),
      enabled: !!id,
      onSuccess: (data) => {
        console.log("checklist details fetched", data);
      }
    });
};

export const updateChecklist = async (id, data) => {
    const response = await fetch(`/api/operational/checklist-instances/${id}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) {
        const errorClone = response.clone();
        const errorText = await errorClone.text();
        console.log("failed to update checklist");
        console.log("error body", errorText);
        throw new Error(`Failed to update checklist ${id}`);
    }

    return response.json();
}

export const useUpdateChecklist = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }) => updateChecklist(id, data),
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries(['checklist', variables.id]);
            queryClient.invalidateQueries(['checklists']);
            return data;
        },
        onError: (error) => {
            console.error("Error updating checklist", error);
            throw error;
        }
    });
};